import api from "./api";

export const calculateAdaptiveTrust = async (payload) => {
    const res = await api.post("/adaptivetrustengine/calculate", {
        userId: Number(payload.userId),
        hasAiAnomaly: Boolean(payload.hasAiAnomaly),
        hasThreatPrediction: Boolean(payload.hasThreatPrediction),
        failedLoginCount: Number(payload.failedLoginCount || 0),
        failedTwoFactorCount: Number(payload.failedTwoFactorCount || 0),
        unknownIp: Boolean(payload.unknownIp),
        suspiciousDevice: Boolean(payload.suspiciousDevice),
    });

    return res.data;
};

export default {
    calculateAdaptiveTrust,
};